
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta } from "/vercel/path0/pages/auth/login.vue?macro=true";
import { default as registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta } from "/vercel/path0/pages/auth/register.vue?macro=true";
import { default as _91id_93rEONDoQiE79kBDm6XcfRc_45jaS9cHrGqzuBkyz7XDAGYMeta } from "/vercel/path0/pages/auth/invite/[id].vue?macro=true";
import { default as editwhNIMCjO7Y6sV4tkg7ik7hoUPkVfrd2bdGzsqjSPcA0Meta } from "/vercel/path0/pages/news/labels/edit.vue?macro=true";
import { default as indexsUfKxnIDAgPxc9BaCl9TGK7RNdmwg2X_by29rzk6Xx4Meta } from "/vercel/path0/pages/onboarding/index.vue?macro=true";
import { default as indexvYu0jRLmgh9rYLxhhyVU2PFsmOIfWyZ6K0CAzj8qZowMeta } from "/vercel/path0/pages/news/labels/index.vue?macro=true";
import { default as createJGTkd799JnJAZ2hEEj0RWUyOxbyQGel4KIL2YCmj5UMMeta } from "/vercel/path0/pages/news/posts/create.vue?macro=true";
import { default as create4J6Aj8tsTAXvAXL_45vEpLofgL9YrMsarO4sK5wzDnwTUMeta } from "/vercel/path0/pages/workspaces/create.vue?macro=true";
import { default as left8vwHFku2A1G5fT9ucQfTkEWYMvEJ57Lrylv3vJUXDwkMeta } from "/vercel/path0/pages/contacts/[id]/left.vue?macro=true";
import { default as _91id_93mY340gPIJaeIfQ9dW_451k9tXxyx0R6ARywThNjThowawMeta } from "/vercel/path0/pages/conversations/[id].vue?macro=true";
import { default as creategZXGxeUdRJR2sJt_4HdK4RI8Hyvg71REiM9guHRI010Meta } from "/vercel/path0/pages/news/labels/create.vue?macro=true";
import { default as indexgPwe6YK9cRsHoN8icPMYrYOLOEtdf8StA6l4iwKI1NkMeta } from "/vercel/path0/pages/settings/api/index.vue?macro=true";
import { default as leftduh_QHwhrCuSPyhON5fvYeOZfbumV3L7el_45duCIzHPIMeta } from "/vercel/path0/pages/companies/[id]/left.vue?macro=true";
import { default as index6mQ1ATzcg_GzDGzpI6aS_45iyV_JzW0pbomkHvlCV50ZYMeta } from "/vercel/path0/pages/contacts/[id]/index.vue?macro=true";
import { default as right6pi5fc_AbE0vKL7_45qGJdtoG2wHKy7ak0pVG_45SpzaY1cMeta } from "/vercel/path0/pages/contacts/[id]/right.vue?macro=true";
import { default as indexdIGWlk80EPjRzGZUp5g_YBgYRzBMi_gkET4I6A8CsHoMeta } from "/vercel/path0/pages/conversations/index.vue?macro=true";
import { default as _91filter_93shb1Gv4LfdMjO3BAjcspCB1zsvoabrGcanlDKF5qK_UMeta } from "/vercel/path0/pages/news/posts/[filter].vue?macro=true";
import { default as indexa55tJfRdx8N438q0vhTpo43bl0IyTfhIpEyEhmH8wPQMeta } from "/vercel/path0/pages/news/settings/index.vue?macro=true";
import { default as forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta } from "/vercel/path0/pages/auth/forgot-password.vue?macro=true";
import { default as index7B3PkiQAqDkcUTVQrZmUUvB9ymIgDKcZVgwengkjbRYMeta } from "/vercel/path0/pages/companies/[id]/index.vue?macro=true";
import { default as right_45XXlGdWMftO7bPXhHthdHLb0PEMvbEQEOt7mLq1GDuUMeta } from "/vercel/path0/pages/companies/[id]/right.vue?macro=true";
import { default as centerLJC8MRaNVeMcaJK6uxJQCD3hYHy5B_45kdZ98YlZGJkgoMeta } from "/vercel/path0/pages/contacts/[id]/center.vue?macro=true";
import { default as header887eqOiGNk_uU4MIYlwP1CIHbX_45NRRhIAUr9MCTtNl0Meta } from "/vercel/path0/pages/contacts/[id]/header.vue?macro=true";
import { default as _91id_93EtOMT7pbQ72p2rjCV2aUOO5aasfsKu_r_45vDoqffJi9wMeta } from "/vercel/path0/pages/news/posts/edit/[id].vue?macro=true";
import { default as headerOY2Nb8JQ_Yzc5YoTCAOlGGSOfyd_45cWHc3jSZpwxQm_gMeta } from "/vercel/path0/pages/companies/[id]/header.vue?macro=true";
import { default as index9C3_Mwmso1s1NKe5ymBejA7rexmygo9vdzs3hd_45YYpgMeta } from "/vercel/path0/pages/helpdesk/settings/index.vue?macro=true";
import { default as sidebarKl_qAU2kMmsQbWKtUqblsDLEB5ReKbSuYBXrCUp_O9UMeta } from "/vercel/path0/pages/news/components/sidebar.vue?macro=true";
import { default as createbfi0syEDlN7BFNssgKAiDGO5Cu7lCbfX7Pu_454oHOCcYMeta } from "/vercel/path0/pages/helpdesk/articles/create.vue?macro=true";
import { default as _91token_93zI61anSUt0fKcEbrCVjoLtxSYxsurEONYP7QOpyc7xUMeta } from "/vercel/path0/pages/auth/verify-email/[token].vue?macro=true";
import { default as right_45barF3t_45Ahtudv9etzUVVpJzHQkIit_45RTCTB4mym_71vI5cMeta } from "/vercel/path0/pages/news/posts/edit/right-bar.vue?macro=true";
import { default as invoicesmp_45R29mS7nrlt4pmvtb25S4NEa_45Cr_45Vkn1W6G_1xEPoMeta } from "/vercel/path0/pages/settings/billing/invoices.vue?macro=true";
import { default as _91filter_93D73lEJ_zaJVHw8wD1k_45QLl__45zGWS9eA6MrnBrPUNtckMeta } from "/vercel/path0/pages/contacts/segments/[filter].vue?macro=true";
import { default as _91filter_93JIHDTd2KIpbVJGhwITpw2L3MYYDUl0k5fvVuAk6KtjcMeta } from "/vercel/path0/pages/helpdesk/articles/[filter].vue?macro=true";
import { default as indexP_45nA5I8NaafQ9PCiixh4M_3hwMD6PhqHsNRp4ziAGkAMeta } from "/vercel/path0/pages/helpdesk/collections/index.vue?macro=true";
import { default as subscribeNP7u5zItTfRhtbeTrjKRfgE7N2MV25VDNiKb_8PURuwMeta } from "/vercel/path0/pages/settings/billing/subscribe.vue?macro=true";
import { default as _91token_93ZoUp_45tTwRu5SIYfe3k49XfghHOOzPfi4plZtdaajsCEMeta } from "/vercel/path0/pages/auth/reset-password/[token].vue?macro=true";
import { default as _91filter_93BHKr5hrZC67Pva4RWS7iOvZopwNmt40Cf4pDuH2wEdIMeta } from "/vercel/path0/pages/companies/segments/[filter].vue?macro=true";
import { default as sidebarUUleJg_2yxHO9IL10k6JqftPelrnxDoaYeZhe_BwKEcMeta } from "/vercel/path0/pages/contacts/components/sidebar.vue?macro=true";
import { default as _91id_93a0aaffoEU5Jfay_iQUTCWe2XPNx_45E8WqPWAEpqSLRcAMeta } from "/vercel/path0/pages/helpdesk/articles/edit/[id].vue?macro=true";
import { default as createLW1rR9aGERL4zlgqUSo9ol3q0RKPfEmc7Du6iRVzsFQMeta } from "/vercel/path0/pages/helpdesk/collections/create.vue?macro=true";
import { default as sidebarxQvaCWEvx0vwaXTj8MzZxS4pVUGZgXyZOpka6elfrSoMeta } from "/vercel/path0/pages/helpdesk/components/sidebar.vue?macro=true";
import { default as indexlywizVYTZwh2t_gfLGqQpXYtA0A7Wz34_SJP8taqXUEMeta } from "/vercel/path0/pages/settings/bot/identity/index.vue?macro=true";
import { default as photoQM1icMbM6nyd3vFLmXbmfxeTt9p_M5vfWsAiisdmikkMeta } from "/vercel/path0/pages/settings/bot/identity/photo.vue?macro=true";
import { default as formSJv_45c4G9EMN0x_RYBjsTj8n9MziF8XPXwwjBmX7ACqoMeta } from "/vercel/path0/pages/workspaces/start-trial/form.vue?macro=true";
import { default as sidebarIYM9PdXlJOmS7LkLhDv_boqv2s_gSB0xKUjC1ATaNJMMeta } from "/vercel/path0/pages/companies/components/sidebar.vue?macro=true";
import { default as mapqH7qZKdcvL8AudLvJnoLUOMP55SnaT27dc4oQZiTPP4Meta } from "/vercel/path0/pages/contacts/[id]/components/map.vue?macro=true";
import { default as tagkydpDIFIslzt0lBQqZb5MJRGQMDd3_YJqB6Lxf0G_45V4Meta } from "/vercel/path0/pages/contacts/[id]/components/tag.vue?macro=true";
import { default as indexUfzAksFSIt1mzPM_45_fp0vmLOxt_45xvTmZtq7dQfXdL8AMeta } from "/vercel/path0/pages/helpdesk/settings/form/index.vue?macro=true";
import { default as change_45plangsAP_45mYbOCCP4Xrr1I2ER2s29Ef6DZGw5_4573TVA9R5sMeta } from "/vercel/path0/pages/settings/billing/change-plan.vue?macro=true";
import { default as editgNPmMklicuruwdFU46Pcp6HC64wKb9Qhqtt9pApVtCAMeta } from "/vercel/path0/pages/settings/workspace/tags/edit.vue?macro=true";
import { default as index6QwBP3NVMd5w_VYJrd46UJInVx75v4a7f5a0hp_45AeOkMeta } from "/vercel/path0/pages/workspaces/start-trial/index.vue?macro=true";
import { default as mapNn_45u5wmNMen_45UFIqHVKe5Y3eGG9hWW3qCwK_4543snQccMeta } from "/vercel/path0/pages/companies/[id]/components/map.vue?macro=true";
import { default as tagac3uxK_45AKCepRXAfzmTCBqa2lLQReT0qZ82tnZNu5qAMeta } from "/vercel/path0/pages/companies/[id]/components/tag.vue?macro=true";
import { default as noteJoCmUGnkXrL6tZ3VVZuHmmuoD3hPBfN8iHgnmANdPLwMeta } from "/vercel/path0/pages/contacts/[id]/components/note.vue?macro=true";
import { default as cardgOnjY8TGcc_lFxUDEO0tD59Gxt7j0IJ5CQzATs3rPv4Meta } from "/vercel/path0/pages/conversations/components/card.vue?macro=true";
import { default as designqAs2AvOyyFofDh_45Ximp9B0urZZSQlgEU9ISlPgxTv_gMeta } from "/vercel/path0/pages/helpdesk/settings/form/design.vue?macro=true";
import { default as domainn1HPltdv7RrsoB8npkGkYQJAwFItjHw2zrzU4fa0YwQMeta } from "/vercel/path0/pages/helpdesk/settings/form/domain.vue?macro=true";
import { default as thumbWeJ7bh40hqHVwJfrkgnlhSGD233GjBtk7P2ay0hiqqsMeta } from "/vercel/path0/pages/news/posts/edit/partial/thumb.vue?macro=true";
import { default as subscriptionPK9gbeZ9_JvcyfUD_ukn1cGgUPbtcH2fKurH7J2wGAYMeta } from "/vercel/path0/pages/settings/billing/subscription.vue?macro=true";
import { default as indexFCN0qk_dswz16d5DxZmVJ3jwUF8p6o2X6N4DzohgMKgMeta } from "/vercel/path0/pages/settings/channels/email/index.vue?macro=true";
import { default as indexRUBvXV9rhNXwHJkNZOrs9sj62ya5MHM7YI3Tycb8cUMMeta } from "/vercel/path0/pages/settings/workspace/tags/index.vue?macro=true";
import { default as editXvybUWhvmIRuRCAAkfwtyEje_k_sjTh6HscYE0S7WFYMeta } from "/vercel/path0/pages/settings/workspace/teams/edit.vue?macro=true";
import { default as resume1_45aIS01ExbQi5TLMPAxZw7GXMZh7Whqz0AClSniWcOYMeta } from "/vercel/path0/pages/workspaces/start-trial/resume.vue?macro=true";
import { default as note1287NwK6oRee1tTDBJX_45glWvBf7p5xes0jEfgCBhctwMeta } from "/vercel/path0/pages/companies/[id]/components/note.vue?macro=true";
import { default as privacyCvV5IEKMwW8jlKq_Np989FN4RjXmp_p0eJFDgCBR2_45kMeta } from "/vercel/path0/pages/helpdesk/settings/form/privacy.vue?macro=true";
import { default as publishcgPYByH0VfAAiUVfJzZFmTV0eeRL4JK7OttPzksVnG8Meta } from "/vercel/path0/pages/helpdesk/settings/form/publish.vue?macro=true";
import { default as createBYdJ3kbv4N8kkJFFRD0iXbHgzb2UidZIs2yXW_45zKWIQMeta } from "/vercel/path0/pages/settings/workspace/tags/create.vue?macro=true";
import { default as indexgiqTNfeh1zpQGG_45hhovPAjOsnVPF66bQ4bsV6B81u7sMeta } from "/vercel/path0/pages/settings/workspace/teams/index.vue?macro=true";
import { default as indexHhFIzSddDfjs6ys_GUP_HTXM5Od1sRzI9XkAnqeP4psMeta } from "/vercel/path0/pages/settings/workspace/users/index.vue?macro=true";
import { default as eventsKptkX9ypR9GkdZi1v56BngQN3Uy76Y4zd9SRTBSQ1tEMeta } from "/vercel/path0/pages/contacts/[id]/components/events.vue?macro=true";
import { default as indexn3Ph8hb5YoHVgy71l5BRChzhRCoPIlAbsUa6G2ompbwMeta } from "/vercel/path0/pages/helpdesk/settings/preview/index.vue?macro=true";
import { default as indexI8F35w5Rc_dwNMBjRAzrjBChBwwTFe_45PV4Bumj4eMdoMeta } from "/vercel/path0/pages/settings/personal/account/index.vue?macro=true";
import { default as photod0f_DDhDsUbOhfZCEgdr8NNgsNqiqpHz7e0Mw38L_7gMeta } from "/vercel/path0/pages/settings/personal/account/photo.vue?macro=true";
import { default as logo6jS9A6DBk2gDJO6_wTuqXXkiyTrfQSmILvXtVcYmMX0Meta } from "/vercel/path0/pages/settings/workspace/general/logo.vue?macro=true";
import { default as createKMSSnwtoCsQJmCu6XhftHfZUGjHFhQOwKmK2JCaZZ9sMeta } from "/vercel/path0/pages/settings/workspace/teams/create.vue?macro=true";
import { default as inviteoE19axLfKNxc_zp9Du7pDu0zLcO4iM1TN2v3pL3pbowMeta } from "/vercel/path0/pages/settings/workspace/users/invite.vue?macro=true";
import { default as companytdrfr9B1QEqqQYjekFDkbsBUbJH2f4_7FSJp5OmpGfoMeta } from "/vercel/path0/pages/contacts/[id]/components/company.vue?macro=true";
import { default as contacttRExAaU6g4FqBjN3B3taN5oudqr_45ElNe7_45dKUeALyCMMeta } from "/vercel/path0/pages/contacts/[id]/components/contact.vue?macro=true";
import { default as right_45bar_wEXOb5E3L0NIw0D8Yp023vdWQ7IwRh8cBVg555Ia_YMeta } from "/vercel/path0/pages/helpdesk/articles/edit/right-bar.vue?macro=true";
import { default as indexo7OgWjdliLigLJUOha4upFDyhroQ_45SR8lXAGOD6h1bUMeta } from "/vercel/path0/pages/settings/bot/qualification/index.vue?macro=true";
import { default as indexccqHeOfEtuHNCDkCvHiuHp_45eBDRzcGEVHY590JEyDoAMeta } from "/vercel/path0/pages/settings/personal/security/index.vue?macro=true";
import { default as indexGYLTdpvdqIOu97TaixsuvYjUK0xc7BbD9E4hsd06qyYMeta } from "/vercel/path0/pages/settings/workspace/general/index.vue?macro=true";
import { default as indexlMrAyUJJbE2KjySp73y18JUCgBOhqDHJFCelrRa2dkkMeta } from "/vercel/path0/pages/settings/channels/messenger/index.vue?macro=true";
import { default as page_45viewfLt_rNJVb0O_CZduupO7xGBN2w_4gHpqeIIbqmGO8D0Meta } from "/vercel/path0/pages/contacts/[id]/components/page-view.vue?macro=true";
import { default as linkSFbBgniMKooqnVCfzXVSCqG8XtQodnqxBjygXT12YrkMeta } from "/vercel/path0/pages/helpdesk/settings/form/footer/link.vue?macro=true";
import { default as link4n9JSb7a9DnTvKEwfACZygPTWplSWdoGtEL4Tn1NnjgMeta } from "/vercel/path0/pages/helpdesk/settings/form/header/link.vue?macro=true";
import { default as logoL4bTmcBJj6_45zy_6Cl_45yK59nbBRbVml4QoLhNqRdNmd4Meta } from "/vercel/path0/pages/helpdesk/settings/form/header/logo.vue?macro=true";
import { default as preview8kcU0ZFXkJU954csM_45ep8g6H7m_2WMpgApHERyh7lAMMeta } from "/vercel/path0/pages/settings/bot/qualification/preview.vue?macro=true";
import { default as inbox_45list3DXOt2O0XzVzsLwQpOomROMHGSxvadfXlbGlb8thxg0Meta } from "/vercel/path0/pages/conversations/components/inbox-list.vue?macro=true";
import { default as indexZe_HfgoRxHjHwGTB0goYzjQLONiwgrBJv0uPkbU_DicMeta } from "/vercel/path0/pages/helpdesk/settings/form/footer/index.vue?macro=true";
import { default as indexG7CzzfEdw3AOV6D_45Hobf3jNui5nHZEKnFil563V6zooMeta } from "/vercel/path0/pages/helpdesk/settings/form/header/index.vue?macro=true";
import { default as imagezYbNuyGU0n0aaDlDQY8lP2K_45OC7lxWMOk92JHXUIBo0Meta } from "/vercel/path0/pages/helpdesk/settings/form/social/image.vue?macro=true";
import { default as indexqcqNq_45u3UQeI05DsqcvMrt_45HK6OrepL5r8vbnti0RqIMeta } from "/vercel/path0/pages/helpdesk/settings/form/social/index.vue?macro=true";
import { default as chat_45headerQAgBi82Y682ycLVDrMaxbL5Dlmd_45VqHOjT2nTTVAjc8Meta } from "/vercel/path0/pages/conversations/components/chat-header.vue?macro=true";
import { default as index7_455jJoJxLbzo6gptk_j488oi0jJPSw0_45qs4Myu4Wf8UMeta } from "/vercel/path0/pages/conversations/components/editor/index.vue?macro=true";
import { default as language_45selectorGrW9I27mywVWkacdQQV4dCU8zNGOEAL1WDrYuZgFlngMeta } from "/vercel/path0/pages/helpdesk/components/language-selector.vue?macro=true";
import { default as indexvMmZGYNUrB4rMRrCdQL1Ez7Ceq4PQa0noZ8Jp3SOqbwMeta } from "/vercel/path0/pages/helpdesk/settings/form/language/index.vue?macro=true";
import { default as faviconbqrFXy1xWWwU_TMMXD_SbCkFahQg_BQmo089jp_45bMPwMeta } from "/vercel/path0/pages/helpdesk/settings/form/social/favicon.vue?macro=true";
import { default as editBXwfcsU6U3XhDTfIyz7M2pZZEgCGPz_TzK5sIPkHfWIMeta } from "/vercel/path0/pages/settings/data/lead-qualification/edit.vue?macro=true";
import { default as indexTbaCJTB66AN8bjAng_45dN4IpAt9XoibxnWqs_ScczmdkMeta } from "/vercel/path0/pages/settings/personal/notifications/index.vue?macro=true";
import { default as data69_CJ_ug74_457fv4MR_454sZ9a6_45_G5yYf8uu0GCCJvPUEMeta } from "/vercel/path0/pages/conversations/components/rightbar/data.vue?macro=true";
import { default as create8PgnETqN2IgJxRdF0dNStau1YNCK8VA_452Yt2llbYkn8Meta } from "/vercel/path0/pages/helpdesk/settings/form/language/create.vue?macro=true";
import { default as index5_45JJ5wSyq3exG4Ku2viVn9JZDRaG3FBSLKpybowb3fAMeta } from "/vercel/path0/pages/settings/data/lead-qualification/index.vue?macro=true";
import { default as indexmqHeEbtkOW_45j28LQukQYDwYx825W1ZnzK_YC0D7rtu0Meta } from "/vercel/path0/pages/conversations/components/rightbar/index.vue?macro=true";
import { default as mobileUYWTpI1pUBg17mCVExzrG6NaVyfKrO8sVQEIMENrqj8Meta } from "/vercel/path0/pages/helpdesk/settings/preview/mockup/mobile.vue?macro=true";
import { default as tablet_45MMRJfDQ0R_0cqdYjyuS6G1vmNVt1D2KhkIGOyhLrIYMeta } from "/vercel/path0/pages/helpdesk/settings/preview/mockup/tablet.vue?macro=true";
import { default as indexth5NGg_45jFCisoB22ZZMggQ5pOqM3H3JsyyYhrPuOC1cMeta } from "/vercel/path0/pages/settings/channels/messenger/setup/index.vue?macro=true";
import { default as createH72KFqkP4_qiZYUYWjYsRVU4NDoE2_45R5Lk04DoJp0T8Meta } from "/vercel/path0/pages/settings/data/lead-qualification/create.vue?macro=true";
import { default as assignP_z60KA1TAoWyeooR9U0WHP_Gb2yjE85n3k9QwZ9HBcMeta } from "/vercel/path0/pages/conversations/components/rightbar/assign.vue?macro=true";
import { default as device1Px0d3dxexfBeO0IZu_45aI_kuNHZ0dldOO8iPszi_jpcMeta } from "/vercel/path0/pages/conversations/components/rightbar/device.vue?macro=true";
import { default as desktopSlhRT0fZMGySreFRoEUpK_45d3JsiZWeUY2XS5h4VL1K4Meta } from "/vercel/path0/pages/helpdesk/settings/preview/mockup/desktop.vue?macro=true";
import { default as contactndVIT5TFjLkctjrck_45gtuOc_4EUyXYnIgZkrak9tHEsMeta } from "/vercel/path0/pages/conversations/components/rightbar/contact.vue?macro=true";
import { default as index4JJQPgXqeBOOtJ7qM8qrBzkoW_7Ad5ylNiwELtlY6MoMeta } from "/vercel/path0/pages/settings/workspace/company-segments/index.vue?macro=true";
import { default as indexhn0MyePHJvbuNkK9nb2SOeBz0NgYt6fFgX5SgyJSlzYMeta } from "/vercel/path0/pages/settings/workspace/contact-segments/index.vue?macro=true";
import { default as chat_45bodyMWmRs2kJy5WqpR1Gw_45YkJ5UOPy0F0qVdmmthz6Yd9lYMeta } from "/vercel/path0/pages/conversations/components/partial/chat-body.vue?macro=true";
import { default as is_45typingtEV5DB9Vect20phZUG5L3yywanY85Ii1xRZ5REj4aZAMeta } from "/vercel/path0/pages/conversations/components/partial/is-typing.vue?macro=true";
import { default as indexHiN1phNNyWN_45dio2EouBLiAERhVs_yDfpb0duSBTdnoMeta } from "/vercel/path0/pages/settings/channels/messenger/security/index.vue?macro=true";
import { default as indextVc1986qOKFjgEgoLNDTHHoWF7YpXQdPKJq1YmubMyEMeta } from "/vercel/path0/pages/settings/workspace/roles-permissions/index.vue?macro=true";
import { default as conversations_45listlQsPY1EbfOsVdCsGF0t4nRd8771Gm8kveBRBt5VFgxIMeta } from "/vercel/path0/pages/conversations/components/conversations-list.vue?macro=true";
import { default as show_45mediaMrGPZDPzXWiq2ZVXCfP_X4GRIw2x75gWhj_45HD3Iz0TUMeta } from "/vercel/path0/pages/conversations/components/partial/show-media.vue?macro=true";
import { default as attributehYa4lMiyt9ZAHB0aCZg5t5HjHcWyby4jmuKslSbK564Meta } from "/vercel/path0/pages/conversations/components/rightbar/attribute.vue?macro=true";
import { default as page_45viewZX0MwxnGWTqd8UsZmDBVFWgYL5EAp5U2wimOtfNVju4Meta } from "/vercel/path0/pages/conversations/components/rightbar/page-view.vue?macro=true";
import { default as create5oe_45b2HnScZsF1EDTa3_SkjnzdPR5y_cQhAUPhdiS2sMeta } from "/vercel/path0/pages/settings/workspace/roles-permissions/create.vue?macro=true";
import { default as indexlh_lN0f9HshcjNEuGBsGOgTIjSaq9mo93uJDt26hhswMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/index.vue?macro=true";
import { default as chat_45messageKoMDh9uF6ZUjgPXf2i5Hja3OSAwisnQKmfj2ohZVaMAMeta } from "/vercel/path0/pages/conversations/components/partial/chat-message.vue?macro=true";
import { default as indexUMxtMqnWcAeKvgVO8bfD_KJJGvjRMSSF_YTQGb15_0IMeta } from "/vercel/path0/pages/settings/channels/messenger/live-preview/index.vue?macro=true";
import { default as format_45messagej7VifWIuyUNnBoAcYY5oHy57ZRabaKmxu4Cvf57Z8kIMeta } from "/vercel/path0/pages/conversations/components/partial/format-message.vue?macro=true";
import { default as chat_45pagination8UP5_45JJ06AlyjUDT1r52UJ5JD41AiiWbqJIQErmna6wMeta } from "/vercel/path0/pages/conversations/components/partial/chat-pagination.vue?macro=true";
import { default as allowed_45domainSPxkiHy6FWM0Yj97UAxBVTieh8_45qCGWVCOahhgwIHcoMeta } from "/vercel/path0/pages/settings/channels/messenger/security/allowed-domain.vue?macro=true";
import { default as indexOyWGcFFGtmkpuU_45LJ_45Cqyng03NDgkPRKwvpHG_RQ7swMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/content/index.vue?macro=true";
import { default as spaceszHHevgh3joPdyQOV8D2WPgxRTd_QWhf5OInWXzUQu_YMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/content/spaces.vue?macro=true";
import { default as AccordionmzAaIsetntkeQLneF25bRpLBcph7Or4dTjheRhWIQ8IMeta } from "/vercel/path0/pages/conversations/components/rightbar/Components/Accordion.vue?macro=true";
import { default as chat_45message_45from_45userUf5qhrZrWZuruOyvgv6_GI8o_45VQuUhnTIUpVk7d4j2kMeta } from "/vercel/path0/pages/conversations/components/partial/chat-message-from-user.vue?macro=true";
import { default as format_45message_45tooltipgLVVq_45U2Ki9wzNx7agbNUJ4RgZVtvKjvHG7gAlVBdCYMeta } from "/vercel/path0/pages/conversations/components/partial/format-message-tooltip.vue?macro=true";
import { default as indexPQLfNlgaaXiX2avL_5I83_45pOsbC_Yi7vXOOgLoLicsoMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/index.vue?macro=true";
import { default as launchertOfRrHpVAAXOIphzDvpr6njdRFiDgVfjnda4_c5pjxcMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/content/launcher.vue?macro=true";
import { default as chat_45message_45from_45contactonoHazDTfAbRDhRTBzrScgrWbhIiY4P_D2q__tl5I9oMeta } from "/vercel/path0/pages/conversations/components/partial/chat-message-from-contact.vue?macro=true";
import { default as identity_45verificationJvlO9CDOgtiv4Ykb_Ex0ueMzjQINlYDNG2wwH_45EVQN4Meta } from "/vercel/path0/pages/settings/channels/messenger/security/identity-verification.vue?macro=true";
import { default as logomYnTKuiM1g7fwikaIn0TySDpMdY2_45lw2o1eN9drturAMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/home/logo.vue?macro=true";
import { default as indexcrTEreV1hTE1p03jra23FLuolbEt9hTZNhx2qyrMLNYMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/home/index.vue?macro=true";
import { default as index3r__VpPJk_HeOn3OZ1QYHgtId6EaEivcsY3oJeaTfBsMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/color/index.vue?macro=true";
import { default as current_45tabhFnCACQXT40vr8DCzBOfiPK_45YAuFQMSTr6_45vIqj1kRIMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/components/current-tab.vue?macro=true";
import { default as help_45oSC9YDS0OSCKxy1wMtboMEpZReBuC1c4DeVq3TKTsMMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/help.vue?macro=true";
import { default as news3Yjwd0W1YYikEhXM6AUMJQpANgFPuuI_455ZhSmHe3nuEMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/news.vue?macro=true";
import { default as indexhCR5s7qqeJ267kMMApo37VzfOLr8g5q7JKN68HIFNagMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/index.vue?macro=true";
import { default as logovYAGJ5Ocxg7mi4jD70lPQCRtcNDZKGBupZ9ycbfDLRgMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/launcher/logo.vue?macro=true";
import { default as footeraH2RvXjqieaMRqj0OA8rn_P5IGlu7MgiCZugrj7bS2UMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/footer.vue?macro=true";
import { default as indexocc_5uQzyVpKFTT_Wz37cEkZh_prFca_3fHH4ILtdS0Meta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/launcher/index.vue?macro=true";
import { default as backgroundgJ0VSDtEB4_jEjlnVwx9Q6btim_45tFX4RJfGKNInrqA0Meta } from "/vercel/path0/pages/settings/channels/messenger/appearance/appearance/home/background.vue?macro=true";
import { default as launcherfglYFED4T6Z2GPmHYwHMVeWGGwKGvcVh3B_LD0PqDBgMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/launcher.vue?macro=true";
import { default as newtlua_MEejxvPFGhDiSe_45zQrtlLf6NhxHdcHORG4VsI4Meta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/new.vue?macro=true";
import { default as indexxNKvmR9tgtnHYs_45AEmWcRiTPY53xw791LkU8HG0ZmWAMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/home/index.vue?macro=true";
import { default as helpfFnCMGqcEOJspOqGdtSZvgOYOPIBn7UPuaFHDu_45eqg0Meta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/help.vue?macro=true";
import { default as home01hg703dzETZnAodgjSSveQ_FVYfQ6ywoQTOtK7aHRgMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/home.vue?macro=true";
import { default as conversationfNEUF7TcqP9lKsmmR3K_45rYKfMhGrxfnJ_45jhvjWkcTPgMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/conversation.vue?macro=true";
import { default as conversationsSITPAZqUK8OxAqni8OxRun3mohZNx1SsWyQbYH2vtHsMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/conversations.vue?macro=true";
import { default as messagedMxWdAB1BsqV3EyzLcU5zWUr6gm3YrLmLL6yKb7C40UMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/message.vue?macro=true";
import { default as searchYwVzMbvnyM_45jYdZHFvlyH7upeYD7lUD8V9a9HsKEb9AMeta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/home/apps/search.vue?macro=true";
import { default as messageaxSKRuYGqE6V_alvuluvh_455_45QgxqFFsKqFLvOOfPvI0Meta } from "/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/home/apps/message.vue?macro=true";
export default [
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta || {},
    component: () => import("/vercel/path0/pages/auth/register.vue")
  },
  {
    name: "auth-invite-id",
    path: "/auth/invite/:id()",
    meta: _91id_93rEONDoQiE79kBDm6XcfRc_45jaS9cHrGqzuBkyz7XDAGYMeta || {},
    component: () => import("/vercel/path0/pages/auth/invite/[id].vue")
  },
  {
    name: "news-labels-edit",
    path: "/news/labels/edit",
    component: () => import("/vercel/path0/pages/news/labels/edit.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/vercel/path0/pages/onboarding/index.vue")
  },
  {
    name: "news-labels",
    path: "/news/labels",
    component: () => import("/vercel/path0/pages/news/labels/index.vue")
  },
  {
    name: "news-posts-create",
    path: "/news/posts/create",
    component: () => import("/vercel/path0/pages/news/posts/create.vue")
  },
  {
    name: "workspaces-create",
    path: "/workspaces/create",
    meta: create4J6Aj8tsTAXvAXL_45vEpLofgL9YrMsarO4sK5wzDnwTUMeta || {},
    component: () => import("/vercel/path0/pages/workspaces/create.vue")
  },
  {
    name: "contacts-id-left",
    path: "/contacts/:id()/left",
    component: () => import("/vercel/path0/pages/contacts/[id]/left.vue")
  },
  {
    name: "conversations-id",
    path: "/conversations/:id()",
    component: () => import("/vercel/path0/pages/conversations/[id].vue")
  },
  {
    name: "news-labels-create",
    path: "/news/labels/create",
    component: () => import("/vercel/path0/pages/news/labels/create.vue")
  },
  {
    name: "settings-api",
    path: "/settings/api",
    component: () => import("/vercel/path0/pages/settings/api/index.vue")
  },
  {
    name: "companies-id-left",
    path: "/companies/:id()/left",
    component: () => import("/vercel/path0/pages/companies/[id]/left.vue")
  },
  {
    name: "contacts-id",
    path: "/contacts/:id()",
    component: () => import("/vercel/path0/pages/contacts/[id]/index.vue")
  },
  {
    name: "contacts-id-right",
    path: "/contacts/:id()/right",
    component: () => import("/vercel/path0/pages/contacts/[id]/right.vue")
  },
  {
    name: "conversations",
    path: "/conversations",
    component: () => import("/vercel/path0/pages/conversations/index.vue")
  },
  {
    name: "news-posts-filter",
    path: "/news/posts/:filter()",
    component: () => import("/vercel/path0/pages/news/posts/[filter].vue")
  },
  {
    name: "news-settings",
    path: "/news/settings",
    component: () => import("/vercel/path0/pages/news/settings/index.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordtAto7006olk3T8pxc58b68rnBOq8ZyKBjsUYZLBF0okMeta || {},
    component: () => import("/vercel/path0/pages/auth/forgot-password.vue")
  },
  {
    name: "companies-id",
    path: "/companies/:id()",
    component: () => import("/vercel/path0/pages/companies/[id]/index.vue")
  },
  {
    name: "companies-id-right",
    path: "/companies/:id()/right",
    component: () => import("/vercel/path0/pages/companies/[id]/right.vue")
  },
  {
    name: "contacts-id-center",
    path: "/contacts/:id()/center",
    component: () => import("/vercel/path0/pages/contacts/[id]/center.vue")
  },
  {
    name: "contacts-id-header",
    path: "/contacts/:id()/header",
    component: () => import("/vercel/path0/pages/contacts/[id]/header.vue")
  },
  {
    name: "news-posts-edit-id",
    path: "/news/posts/edit/:id()",
    component: () => import("/vercel/path0/pages/news/posts/edit/[id].vue")
  },
  {
    name: "companies-id-header",
    path: "/companies/:id()/header",
    component: () => import("/vercel/path0/pages/companies/[id]/header.vue")
  },
  {
    name: "helpdesk-settings",
    path: "/helpdesk/settings",
    component: () => import("/vercel/path0/pages/helpdesk/settings/index.vue")
  },
  {
    name: "news-components-sidebar",
    path: "/news/components/sidebar",
    component: () => import("/vercel/path0/pages/news/components/sidebar.vue")
  },
  {
    name: "helpdesk-articles-create",
    path: "/helpdesk/articles/create",
    component: () => import("/vercel/path0/pages/helpdesk/articles/create.vue")
  },
  {
    name: "auth-verify-email-token",
    path: "/auth/verify-email/:token()",
    meta: _91token_93zI61anSUt0fKcEbrCVjoLtxSYxsurEONYP7QOpyc7xUMeta || {},
    component: () => import("/vercel/path0/pages/auth/verify-email/[token].vue")
  },
  {
    name: "news-posts-edit-right-bar",
    path: "/news/posts/edit/right-bar",
    component: () => import("/vercel/path0/pages/news/posts/edit/right-bar.vue")
  },
  {
    name: "settings-billing-invoices",
    path: "/settings/billing/invoices",
    component: () => import("/vercel/path0/pages/settings/billing/invoices.vue")
  },
  {
    name: "contacts-segments-filter",
    path: "/contacts/segments/:filter()",
    component: () => import("/vercel/path0/pages/contacts/segments/[filter].vue")
  },
  {
    name: "helpdesk-articles-filter",
    path: "/helpdesk/articles/:filter()",
    component: () => import("/vercel/path0/pages/helpdesk/articles/[filter].vue")
  },
  {
    name: "helpdesk-collections",
    path: "/helpdesk/collections",
    component: () => import("/vercel/path0/pages/helpdesk/collections/index.vue")
  },
  {
    name: "settings-billing-subscribe",
    path: "/settings/billing/subscribe",
    component: () => import("/vercel/path0/pages/settings/billing/subscribe.vue")
  },
  {
    name: "auth-reset-password-token",
    path: "/auth/reset-password/:token()",
    meta: _91token_93ZoUp_45tTwRu5SIYfe3k49XfghHOOzPfi4plZtdaajsCEMeta || {},
    component: () => import("/vercel/path0/pages/auth/reset-password/[token].vue")
  },
  {
    name: "companies-segments-filter",
    path: "/companies/segments/:filter()",
    component: () => import("/vercel/path0/pages/companies/segments/[filter].vue")
  },
  {
    name: "contacts-components-sidebar",
    path: "/contacts/components/sidebar",
    component: () => import("/vercel/path0/pages/contacts/components/sidebar.vue")
  },
  {
    name: "helpdesk-articles-edit-id",
    path: "/helpdesk/articles/edit/:id()",
    component: () => import("/vercel/path0/pages/helpdesk/articles/edit/[id].vue")
  },
  {
    name: "helpdesk-collections-create",
    path: "/helpdesk/collections/create",
    component: () => import("/vercel/path0/pages/helpdesk/collections/create.vue")
  },
  {
    name: "helpdesk-components-sidebar",
    path: "/helpdesk/components/sidebar",
    component: () => import("/vercel/path0/pages/helpdesk/components/sidebar.vue")
  },
  {
    name: "settings-bot-identity",
    path: "/settings/bot/identity",
    component: () => import("/vercel/path0/pages/settings/bot/identity/index.vue")
  },
  {
    name: "settings-bot-identity-photo",
    path: "/settings/bot/identity/photo",
    component: () => import("/vercel/path0/pages/settings/bot/identity/photo.vue")
  },
  {
    name: "workspaces-start-trial-form",
    path: "/workspaces/start-trial/form",
    component: () => import("/vercel/path0/pages/workspaces/start-trial/form.vue")
  },
  {
    name: "companies-components-sidebar",
    path: "/companies/components/sidebar",
    component: () => import("/vercel/path0/pages/companies/components/sidebar.vue")
  },
  {
    name: "contacts-id-components-map",
    path: "/contacts/:id()/components/map",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/map.vue")
  },
  {
    name: "contacts-id-components-tag",
    path: "/contacts/:id()/components/tag",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/tag.vue")
  },
  {
    name: "helpdesk-settings-form",
    path: "/helpdesk/settings/form",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/index.vue")
  },
  {
    name: "settings-billing-change-plan",
    path: "/settings/billing/change-plan",
    component: () => import("/vercel/path0/pages/settings/billing/change-plan.vue")
  },
  {
    name: "settings-workspace-tags-edit",
    path: "/settings/workspace/tags/edit",
    component: () => import("/vercel/path0/pages/settings/workspace/tags/edit.vue")
  },
  {
    name: "workspaces-start-trial",
    path: "/workspaces/start-trial",
    component: () => import("/vercel/path0/pages/workspaces/start-trial/index.vue")
  },
  {
    name: "companies-id-components-map",
    path: "/companies/:id()/components/map",
    component: () => import("/vercel/path0/pages/companies/[id]/components/map.vue")
  },
  {
    name: "companies-id-components-tag",
    path: "/companies/:id()/components/tag",
    component: () => import("/vercel/path0/pages/companies/[id]/components/tag.vue")
  },
  {
    name: "contacts-id-components-note",
    path: "/contacts/:id()/components/note",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/note.vue")
  },
  {
    name: "conversations-components-card",
    path: "/conversations/components/card",
    component: () => import("/vercel/path0/pages/conversations/components/card.vue")
  },
  {
    name: "helpdesk-settings-form-design",
    path: "/helpdesk/settings/form/design",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/design.vue")
  },
  {
    name: "helpdesk-settings-form-domain",
    path: "/helpdesk/settings/form/domain",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/domain.vue")
  },
  {
    name: "news-posts-edit-partial-thumb",
    path: "/news/posts/edit/partial/thumb",
    component: () => import("/vercel/path0/pages/news/posts/edit/partial/thumb.vue")
  },
  {
    name: "settings-billing-subscription",
    path: "/settings/billing/subscription",
    component: () => import("/vercel/path0/pages/settings/billing/subscription.vue")
  },
  {
    name: "settings-channels-email",
    path: "/settings/channels/email",
    component: () => import("/vercel/path0/pages/settings/channels/email/index.vue")
  },
  {
    name: "settings-workspace-tags",
    path: "/settings/workspace/tags",
    component: () => import("/vercel/path0/pages/settings/workspace/tags/index.vue")
  },
  {
    name: "settings-workspace-teams-edit",
    path: "/settings/workspace/teams/edit",
    component: () => import("/vercel/path0/pages/settings/workspace/teams/edit.vue")
  },
  {
    name: "workspaces-start-trial-resume",
    path: "/workspaces/start-trial/resume",
    component: () => import("/vercel/path0/pages/workspaces/start-trial/resume.vue")
  },
  {
    name: "companies-id-components-note",
    path: "/companies/:id()/components/note",
    component: () => import("/vercel/path0/pages/companies/[id]/components/note.vue")
  },
  {
    name: "helpdesk-settings-form-privacy",
    path: "/helpdesk/settings/form/privacy",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/privacy.vue")
  },
  {
    name: "helpdesk-settings-form-publish",
    path: "/helpdesk/settings/form/publish",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/publish.vue")
  },
  {
    name: "settings-workspace-tags-create",
    path: "/settings/workspace/tags/create",
    component: () => import("/vercel/path0/pages/settings/workspace/tags/create.vue")
  },
  {
    name: "settings-workspace-teams",
    path: "/settings/workspace/teams",
    component: () => import("/vercel/path0/pages/settings/workspace/teams/index.vue")
  },
  {
    name: "settings-workspace-users",
    path: "/settings/workspace/users",
    component: () => import("/vercel/path0/pages/settings/workspace/users/index.vue")
  },
  {
    name: "contacts-id-components-events",
    path: "/contacts/:id()/components/events",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/events.vue")
  },
  {
    name: "helpdesk-settings-preview",
    path: "/helpdesk/settings/preview",
    component: () => import("/vercel/path0/pages/helpdesk/settings/preview/index.vue")
  },
  {
    name: "settings-personal-account",
    path: "/settings/personal/account",
    component: () => import("/vercel/path0/pages/settings/personal/account/index.vue")
  },
  {
    name: "settings-personal-account-photo",
    path: "/settings/personal/account/photo",
    component: () => import("/vercel/path0/pages/settings/personal/account/photo.vue")
  },
  {
    name: "settings-workspace-general-logo",
    path: "/settings/workspace/general/logo",
    component: () => import("/vercel/path0/pages/settings/workspace/general/logo.vue")
  },
  {
    name: "settings-workspace-teams-create",
    path: "/settings/workspace/teams/create",
    component: () => import("/vercel/path0/pages/settings/workspace/teams/create.vue")
  },
  {
    name: "settings-workspace-users-invite",
    path: "/settings/workspace/users/invite",
    component: () => import("/vercel/path0/pages/settings/workspace/users/invite.vue")
  },
  {
    name: "contacts-id-components-company",
    path: "/contacts/:id()/components/company",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/company.vue")
  },
  {
    name: "contacts-id-components-contact",
    path: "/contacts/:id()/components/contact",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/contact.vue")
  },
  {
    name: "helpdesk-articles-edit-right-bar",
    path: "/helpdesk/articles/edit/right-bar",
    component: () => import("/vercel/path0/pages/helpdesk/articles/edit/right-bar.vue")
  },
  {
    name: "settings-bot-qualification",
    path: "/settings/bot/qualification",
    component: () => import("/vercel/path0/pages/settings/bot/qualification/index.vue")
  },
  {
    name: "settings-personal-security",
    path: "/settings/personal/security",
    component: () => import("/vercel/path0/pages/settings/personal/security/index.vue")
  },
  {
    name: "settings-workspace-general",
    path: "/settings/workspace/general",
    component: () => import("/vercel/path0/pages/settings/workspace/general/index.vue")
  },
  {
    name: "settings-channels-messenger",
    path: "/settings/channels/messenger",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/index.vue")
  },
  {
    name: "contacts-id-components-page-view",
    path: "/contacts/:id()/components/page-view",
    component: () => import("/vercel/path0/pages/contacts/[id]/components/page-view.vue")
  },
  {
    name: "helpdesk-settings-form-footer-link",
    path: "/helpdesk/settings/form/footer/link",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/footer/link.vue")
  },
  {
    name: "helpdesk-settings-form-header-link",
    path: "/helpdesk/settings/form/header/link",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/header/link.vue")
  },
  {
    name: "helpdesk-settings-form-header-logo",
    path: "/helpdesk/settings/form/header/logo",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/header/logo.vue")
  },
  {
    name: "settings-bot-qualification-preview",
    path: "/settings/bot/qualification/preview",
    component: () => import("/vercel/path0/pages/settings/bot/qualification/preview.vue")
  },
  {
    name: "conversations-components-inbox-list",
    path: "/conversations/components/inbox-list",
    component: () => import("/vercel/path0/pages/conversations/components/inbox-list.vue")
  },
  {
    name: "helpdesk-settings-form-footer",
    path: "/helpdesk/settings/form/footer",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/footer/index.vue")
  },
  {
    name: "helpdesk-settings-form-header",
    path: "/helpdesk/settings/form/header",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/header/index.vue")
  },
  {
    name: "helpdesk-settings-form-social-image",
    path: "/helpdesk/settings/form/social/image",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/social/image.vue")
  },
  {
    name: "helpdesk-settings-form-social",
    path: "/helpdesk/settings/form/social",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/social/index.vue")
  },
  {
    name: "conversations-components-chat-header",
    path: "/conversations/components/chat-header",
    component: () => import("/vercel/path0/pages/conversations/components/chat-header.vue")
  },
  {
    name: "conversations-components-editor",
    path: "/conversations/components/editor",
    component: () => import("/vercel/path0/pages/conversations/components/editor/index.vue")
  },
  {
    name: "helpdesk-components-language-selector",
    path: "/helpdesk/components/language-selector",
    component: () => import("/vercel/path0/pages/helpdesk/components/language-selector.vue")
  },
  {
    name: "helpdesk-settings-form-language",
    path: "/helpdesk/settings/form/language",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/language/index.vue")
  },
  {
    name: "helpdesk-settings-form-social-favicon",
    path: "/helpdesk/settings/form/social/favicon",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/social/favicon.vue")
  },
  {
    name: "settings-data-lead-qualification-edit",
    path: "/settings/data/lead-qualification/edit",
    component: () => import("/vercel/path0/pages/settings/data/lead-qualification/edit.vue")
  },
  {
    name: "settings-personal-notifications",
    path: "/settings/personal/notifications",
    component: () => import("/vercel/path0/pages/settings/personal/notifications/index.vue")
  },
  {
    name: "conversations-components-rightbar-data",
    path: "/conversations/components/rightbar/data",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/data.vue")
  },
  {
    name: "helpdesk-settings-form-language-create",
    path: "/helpdesk/settings/form/language/create",
    component: () => import("/vercel/path0/pages/helpdesk/settings/form/language/create.vue")
  },
  {
    name: "settings-data-lead-qualification",
    path: "/settings/data/lead-qualification",
    component: () => import("/vercel/path0/pages/settings/data/lead-qualification/index.vue")
  },
  {
    name: "conversations-components-rightbar",
    path: "/conversations/components/rightbar",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/index.vue")
  },
  {
    name: "helpdesk-settings-preview-mockup-mobile",
    path: "/helpdesk/settings/preview/mockup/mobile",
    component: () => import("/vercel/path0/pages/helpdesk/settings/preview/mockup/mobile.vue")
  },
  {
    name: "helpdesk-settings-preview-mockup-tablet",
    path: "/helpdesk/settings/preview/mockup/tablet",
    component: () => import("/vercel/path0/pages/helpdesk/settings/preview/mockup/tablet.vue")
  },
  {
    name: "settings-channels-messenger-setup",
    path: "/settings/channels/messenger/setup",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/setup/index.vue")
  },
  {
    name: "settings-data-lead-qualification-create",
    path: "/settings/data/lead-qualification/create",
    component: () => import("/vercel/path0/pages/settings/data/lead-qualification/create.vue")
  },
  {
    name: "conversations-components-rightbar-assign",
    path: "/conversations/components/rightbar/assign",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/assign.vue")
  },
  {
    name: "conversations-components-rightbar-device",
    path: "/conversations/components/rightbar/device",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/device.vue")
  },
  {
    name: "helpdesk-settings-preview-mockup-desktop",
    path: "/helpdesk/settings/preview/mockup/desktop",
    component: () => import("/vercel/path0/pages/helpdesk/settings/preview/mockup/desktop.vue")
  },
  {
    name: "conversations-components-rightbar-contact",
    path: "/conversations/components/rightbar/contact",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/contact.vue")
  },
  {
    name: "settings-workspace-company-segments",
    path: "/settings/workspace/company-segments",
    component: () => import("/vercel/path0/pages/settings/workspace/company-segments/index.vue")
  },
  {
    name: "settings-workspace-contact-segments",
    path: "/settings/workspace/contact-segments",
    component: () => import("/vercel/path0/pages/settings/workspace/contact-segments/index.vue")
  },
  {
    name: "conversations-components-partial-chat-body",
    path: "/conversations/components/partial/chat-body",
    component: () => import("/vercel/path0/pages/conversations/components/partial/chat-body.vue")
  },
  {
    name: "conversations-components-partial-is-typing",
    path: "/conversations/components/partial/is-typing",
    component: () => import("/vercel/path0/pages/conversations/components/partial/is-typing.vue")
  },
  {
    name: "settings-channels-messenger-security",
    path: "/settings/channels/messenger/security",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/security/index.vue")
  },
  {
    name: "settings-workspace-roles-permissions",
    path: "/settings/workspace/roles-permissions",
    component: () => import("/vercel/path0/pages/settings/workspace/roles-permissions/index.vue")
  },
  {
    name: "conversations-components-conversations-list",
    path: "/conversations/components/conversations-list",
    component: () => import("/vercel/path0/pages/conversations/components/conversations-list.vue")
  },
  {
    name: "conversations-components-partial-show-media",
    path: "/conversations/components/partial/show-media",
    component: () => import("/vercel/path0/pages/conversations/components/partial/show-media.vue")
  },
  {
    name: "conversations-components-rightbar-attribute",
    path: "/conversations/components/rightbar/attribute",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/attribute.vue")
  },
  {
    name: "conversations-components-rightbar-page-view",
    path: "/conversations/components/rightbar/page-view",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/page-view.vue")
  },
  {
    name: "settings-workspace-roles-permissions-create",
    path: "/settings/workspace/roles-permissions/create",
    component: () => import("/vercel/path0/pages/settings/workspace/roles-permissions/create.vue")
  },
  {
    name: "settings-channels-messenger-appearance",
    path: "/settings/channels/messenger/appearance",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/index.vue")
  },
  {
    name: "conversations-components-partial-chat-message",
    path: "/conversations/components/partial/chat-message",
    component: () => import("/vercel/path0/pages/conversations/components/partial/chat-message.vue")
  },
  {
    name: "settings-channels-messenger-live-preview",
    path: "/settings/channels/messenger/live-preview",
    meta: indexUMxtMqnWcAeKvgVO8bfD_KJJGvjRMSSF_YTQGb15_0IMeta || {},
    component: () => import("/vercel/path0/pages/settings/channels/messenger/live-preview/index.vue")
  },
  {
    name: "conversations-components-partial-format-message",
    path: "/conversations/components/partial/format-message",
    component: () => import("/vercel/path0/pages/conversations/components/partial/format-message.vue")
  },
  {
    name: "conversations-components-partial-chat-pagination",
    path: "/conversations/components/partial/chat-pagination",
    component: () => import("/vercel/path0/pages/conversations/components/partial/chat-pagination.vue")
  },
  {
    name: "settings-channels-messenger-security-allowed-domain",
    path: "/settings/channels/messenger/security/allowed-domain",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/security/allowed-domain.vue")
  },
  {
    name: "settings-channels-messenger-appearance-content",
    path: "/settings/channels/messenger/appearance/content",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/content/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-content-spaces",
    path: "/settings/channels/messenger/appearance/content/spaces",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/content/spaces.vue")
  },
  {
    name: "conversations-components-rightbar-Components-Accordion",
    path: "/conversations/components/rightbar/Components/Accordion",
    component: () => import("/vercel/path0/pages/conversations/components/rightbar/Components/Accordion.vue")
  },
  {
    name: "conversations-components-partial-chat-message-from-user",
    path: "/conversations/components/partial/chat-message-from-user",
    component: () => import("/vercel/path0/pages/conversations/components/partial/chat-message-from-user.vue")
  },
  {
    name: "conversations-components-partial-format-message-tooltip",
    path: "/conversations/components/partial/format-message-tooltip",
    component: () => import("/vercel/path0/pages/conversations/components/partial/format-message-tooltip.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance",
    path: "/settings/channels/messenger/appearance/appearance",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-content-launcher",
    path: "/settings/channels/messenger/appearance/content/launcher",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/content/launcher.vue")
  },
  {
    name: "conversations-components-partial-chat-message-from-contact",
    path: "/conversations/components/partial/chat-message-from-contact",
    component: () => import("/vercel/path0/pages/conversations/components/partial/chat-message-from-contact.vue")
  },
  {
    name: "settings-channels-messenger-security-identity-verification",
    path: "/settings/channels/messenger/security/identity-verification",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/security/identity-verification.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance-home-logo",
    path: "/settings/channels/messenger/appearance/appearance/home/logo",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/home/logo.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance-home",
    path: "/settings/channels/messenger/appearance/appearance/home",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/home/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance-color",
    path: "/settings/channels/messenger/appearance/appearance/color",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/color/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-components-current-tab",
    path: "/settings/channels/messenger/appearance/components/current-tab",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/components/current-tab.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-help",
    path: "/settings/channels/messenger/appearance/preview/messenger/help",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/help.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-news",
    path: "/settings/channels/messenger/appearance/preview/messenger/news",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/news.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger",
    path: "/settings/channels/messenger/appearance/preview/messenger",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance-launcher-logo",
    path: "/settings/channels/messenger/appearance/appearance/launcher/logo",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/launcher/logo.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-footer",
    path: "/settings/channels/messenger/appearance/preview/messenger/footer",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/footer.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance-launcher",
    path: "/settings/channels/messenger/appearance/appearance/launcher",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/launcher/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-appearance-home-background",
    path: "/settings/channels/messenger/appearance/appearance/home/background",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/appearance/home/background.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-launcher",
    path: "/settings/channels/messenger/appearance/preview/messenger/launcher",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/launcher.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-icons-new",
    path: "/settings/channels/messenger/appearance/preview/messenger/icons/new",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/new.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-home",
    path: "/settings/channels/messenger/appearance/preview/messenger/home",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/home/index.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-icons-help",
    path: "/settings/channels/messenger/appearance/preview/messenger/icons/help",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/help.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-icons-home",
    path: "/settings/channels/messenger/appearance/preview/messenger/icons/home",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/home.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-conversation",
    path: "/settings/channels/messenger/appearance/preview/messenger/conversation",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/conversation.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-conversations",
    path: "/settings/channels/messenger/appearance/preview/messenger/conversations",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/conversations.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-icons-message",
    path: "/settings/channels/messenger/appearance/preview/messenger/icons/message",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/icons/message.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-home-apps-search",
    path: "/settings/channels/messenger/appearance/preview/messenger/home/apps/search",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/home/apps/search.vue")
  },
  {
    name: "settings-channels-messenger-appearance-preview-messenger-home-apps-message",
    path: "/settings/channels/messenger/appearance/preview/messenger/home/apps/message",
    component: () => import("/vercel/path0/pages/settings/channels/messenger/appearance/preview/messenger/home/apps/message.vue")
  }
]